"use strict";
var uncurryThis = require("../internals/function-uncurry-this");
var requireObjectCoercible = require("../internals/require-object-coercible");
var toString = require("../internals/to-string");
var quot = /"/g;
var replace = uncurryThis("".replace);
module.exports = function(string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = "<" + tag;
  if (attribute !== "") p1 += " " + attribute + '="' + replace(toString(value), quot, "&quot;") + '"';
  return p1 + ">" + S + "</" + tag + ">";
};
